import React from "react";
import styled from "styled-components";
import {ProductListHeader, SimpleProductsList} from "@ui";
import useTheme from "@mock/hooks/useTheme.js";
import {useThemeComponents} from "@mock/hooks/useThemeComponents";
import productsListStyles from "@themes/default/components/ShowcaseProductsList/ProductsList/styles";
import useShowcaseProductsList from "@mock/hooks/useShowcaseProductsList";
import {useInView} from "react-intersection-observer";

export default function ProductsList({keepQuery = true, ...props}) {
  const {name, description, slug, type, url} = props;

  const {ref, inView} = useInView({
    triggerOnce: true,
  });

  const theme = useTheme();
  const {ViewAllLink} = useThemeComponents();

  const {site, ...baseProps} = useShowcaseProductsList({
    inView,
    slug,
    type,
    url,
    filters: props.filters,
  });

  const styles = productsListStyles(theme, site);

  const productsPerSlide = styles.element.elementsPerRow || {
    lg: 6,
    md: 6,
    sm: 6,
  };

  return (
    <ProductListContainer ref={ref}>
      <SimpleProductsList
        {...props}
        {...baseProps}
        styles={styles}
        maxProducts={productsPerSlide}
        HeaderComponent={
          <ProductListHeader
            title={name}
            description={description}
            ViewAllComponent={
              <ViewAllLink
                accessibilityIdentifier={slug}
                to={url}
                keepQuery={keepQuery}
              />
            }
          />
        }
      />
    </ProductListContainer>
  );
}

const ProductListContainer = styled.div`
  min-height: 500px;

  &:not(:last-of-type) {
    margin-bottom: 20px;
  }
`;
